/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import { NavItem, NavLink, Nav, Badge } from 'reactstrap';
import firebase from '../../config/firebase.config';
import BlockUi from 'react-block-ui';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import styles from './Sidebar.module.scss';
import classNames from 'classnames';
import { managementItems, teamReportItems } from './Sidebar.constants';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { useFeatures } from '@/hooks/useFeatures';
import { Button, buttonVariants } from '@/components/Button';
import { authActionTypes } from '@store/Auth/Auth.actionTypes';
import { MdLogout } from 'react-icons/md';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
const database = firebase.firestore();
const CustomNavItem = ({ closeCollapse }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [unreadAlertsCount, setUnreadAlertsCount] = useState(0);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [isTeamReportCollapsed, setIsTeamReportCollapsed] = useState(false);
  const [isManagementCollapsed, setIsManagementCollapsed] = useState(false);
  const { hasAccess } = useFeatures();
  const teamReducer = useSelector((state) => ({
    loading: false,
    activeTeam: state.team.activeTeam,
    activeUserID: state.team.activeUserID,
    members: state.team.teamMembers,
    teams: state.team.teams,
    all: state.team.all,
    timelogDayRange: state.team.timelogDayRange,
    start: state.start,
    end: state.end,
    week: state.team.week,
  }));

  const userProfile = useSelector((state) => state.auth.profile);
  const routeReducer = useSelector((state) => ({
    location: state?.router?.location,
  }));

  useLayoutEffect(() => {
    dispatch({
      type: teamActionTypes.GET_USER_ACTIVE_TEAM,
      payload: {
        userId: userProfile?.id,
        companyId: !_.isEmpty(userProfile?.activeCompany)
          ? userProfile?.activeCompany?.companyId
          : '',
        role: !_.isEmpty(userProfile?.role) ? userProfile?.role : '',
        days: teamReducer.timelogDayRange,
        start: teamReducer.start,
        end: teamReducer.end,
      },
    });
  }, [userProfile]);

  useEffect(() => {
    if (teamReducer.activeTeam.activeTeamid !== undefined) {
      dispatch({
        type: teamActionTypes.SET_TODAY_TIMES,
        payload: {
          selectedTeamID: teamReducer.activeTeam.activeTeamid,
          day: teamReducer.timelogDayRange,
        },
      });
      dispatch({
        type: teamActionTypes.SET_TRENDS_DATA,
        payload: {
          selectedTeamID: teamReducer.activeTeam.activeTeamid,
          week: teamReducer.week,
        },
      });
      // dispatch({
      //   type: "team/SET_TOP_USERS",
      //   payload: {
      //     selectedTeamID: teamReducer.activeTeam.activeTeamid,
      //     day: teamReducer.timelogDayRange,
      //   },
      // });
    }
  }, [teamReducer.activeTeam.activeTeamid]);

  let members = [];
  if (!isEmpty(teamReducer.members)) {
    const activeMember = find(
      teamReducer.members,
      (value) => value.userUID === userProfile?.id
    );
    if (activeMember) {
      if (activeMember.userType === 'Manager') {
        const sortMembers = filter(
          teamReducer.members,
          (value) => value.userUID !== userProfile?.id
        );
        const currentMember = find(
          teamReducer.members,
          (value) => value.userUID === userProfile?.id
        );
        members = [...sortMembers, currentMember];
      } else {
        members = filter(
          teamReducer.members,
          (value) => value.userUID === userProfile?.id
        );
      }
    }
  }

  function handleRouting(navItem) {
    if (navItem.external && navItem.navLink) {
      window.open(navItem.navLink, '_blank', 'noopener,noreferrer');
      closeCollapse();
      return;
    }
    let navUrl = navItem.navLink;
    // if (navItem.id === "team-dashboard") {
    //   const companyId = !_.isEmpty(userProfile?.activeCompany)
    //     ? userProfile?.activeCompany?.companyId
    //     : "";
    //   navUrl += `?cid=${companyId}`;
    // }
    history.push(navUrl);
    closeCollapse();
  }

  // Check if user has an active company
  const hasActiveCompany = !isEmpty(userProfile?.activeCompany?.companyId);

  // Check if user profile is loaded
  const isProfileLoaded = userProfile && userProfile.id;

  // Check if user has companies but no active company
  const hasCompaniesButNoActive =
    userProfile?.companyList &&
    userProfile.companyList.length > 0 &&
    !hasActiveCompany;

  // Debug logging
  console.log('Sidebar Debug:', {
    isProfileLoaded,
    hasActiveCompany,
    hasCompaniesButNoActive,
    activeCompany: userProfile?.activeCompany,
    companyList: userProfile?.companyList,
    companyListLength: userProfile?.companyList?.length,
  });

  // Filter navItems based on company dependency
  //alerttoask
  let filteredTeamReportItems = teamReportItems;
  let filteredManagementItems = managementItems;
  filteredTeamReportItems = filteredTeamReportItems.filter((item) => {
    if (item.moduleId) {
      return hasAccess.module(item.moduleId);
    }
    return true;
  });
  filteredManagementItems = filteredManagementItems.filter((item) => {
    if (item.moduleId) {
      return hasAccess.module(item.moduleId);
    }
    return true;
  });
  if (!isProfileLoaded) {
    filteredTeamReportItems = teamReportItems;
    filteredManagementItems = managementItems;
    // Show loading state - keep all items visible while loading
  } else if (!hasActiveCompany) {
    // When no active company, show only invitations
    filteredTeamReportItems = filteredTeamReportItems.filter(
      (item) =>
        item.id === 'invitations-hub' ||
        item.id === 'download-desktop-app' ||
        item.id === 'support-portal'
    );
    filteredManagementItems = filteredManagementItems.filter(
      (item) =>
        item.id === 'invitations-hub' ||
        item.id === 'download-desktop-app' ||
        item.id === 'support-portal'
    );
  } else {
    // When active company exists, apply role-based filtering
    if (userProfile?.activeCompany?.role === 'Member') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) => obj.title !== 'Projects'
      );
    }
    if (
      userProfile?.activeCompany?.role === 'Member' ||
      userProfile?.activeCompany?.role === 'Client'
    ) {
      filteredTeamReportItems = filteredTeamReportItems.filter(
        (obj) => obj.title !== 'Attendance'
      );
    }
    if (
      userProfile?.activeCompany?.role === 'Member' ||
      userProfile?.activeCompany?.role === 'Client'
    ) {
      filteredTeamReportItems = filteredTeamReportItems.filter(
        (obj) => obj.title !== 'Team'
      );
    }

    if (userProfile?.activeCompany?.role === 'Member') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) =>
          obj.id !== 'requests' &&
          obj.id !== 'leaverequest' &&
          obj.id !== 'team-attendance'
      );
    }

    // Only show Invoices to Admin users
    if (userProfile?.activeCompany?.role !== 'Admin') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) => obj.id !== 'billing'
      );
    }

    // Add Employee: direct provisioning when stealth is on, invitations when off
    if (userProfile?.activeCompany?.role !== 'Admin') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) => obj.id !== 'add-employee'
      );
    }

    // Only show Employee List and Team List to Admin users (visible regardless of stealth mode)
    if (userProfile?.activeCompany?.role !== 'Admin') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) => obj.id !== 'employee-list' && obj.id !== 'team-list'
      );
    }

    // Settings: company managers/admins only
    if (userProfile?.activeCompany?.role === 'Member') {
      filteredManagementItems = filteredManagementItems.filter(
        (obj) => obj.id !== 'settings'
      );
    }
  }
  // Listen to unread alerts count
  // Alerts are stored in membersDatabase/{userId}/alerts subcollection
  useEffect(() => {
    const userId = userProfile?.id;
    if (!userId) {
      setUnreadAlertsCount(0);
      return;
    }

    const unsubscribe = database
      .collection('membersDatabase')
      .doc(userId)
      .collection('alerts')
      .where('isRead', '==', false)
      .onSnapshot(
        (snapshot) => {
          setUnreadAlertsCount(snapshot.size);
        },
        (error) => {
          console.error('Error listening to unread alerts count:', error);
          setUnreadAlertsCount(0);
        }
      );
    const unsubscribeNotifications = database
      .collection('membersDatabase')
      .doc(userId)
      .collection('notifications')
      .where('isRead', '==', false)
      .onSnapshot(
        (snapshot) => {
          setUnreadNotificationsCount(snapshot.size);
        },
        (error) => {
          console.error(
            'Error listening to unread notifications count:',
            error
          );
          setUnreadNotificationsCount(0);
        }
      );
    return () => {
      unsubscribe();
      unsubscribeNotifications();
    };
  }, [userProfile?.id]);
  const getIsNavItemActive = (navItem) => {
    if (navItem.external) return false;
    return routeReducer.location.pathname === navItem.navLink;
  };
  return (
    <BlockUi tag="div" blocking={teamReducer.loading}>
      <Nav navbar>
        {/* Show helpful message when no active company */}
        {isProfileLoaded && !hasActiveCompany && (
          <NavItem>
            <div
              className="px-3 py-3 text-center border border-primary rounded mx-2 mb-2"
              style={{ backgroundColor: '#e3f2fd' }}
            >
              <small className="text-muted d-block mb-2">
                <i className="fas fa-info-circle mr-1 text-primary"></i>
                {hasCompaniesButNoActive
                  ? 'Select a company to access team features'
                  : 'Create a company to access team features'}
              </small>
              <div className="d-flex flex-column gap-2">
                {hasCompaniesButNoActive ? (
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      history.push('/select-company');
                      closeCollapse();
                    }}
                  >
                    Select Company
                  </button>
                ) : (
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      history.push('/add-company');
                      closeCollapse();
                    }}
                  >
                    Create Company
                  </button>
                )}
              </div>
            </div>
          </NavItem>
        )}
        <div className={classNames(styles.navItemsContainer, 'with-scroll')}>
          {hasActiveCompany && (
            <React.Fragment>
              <hr style={{ margin: 0 }} />
              <NavItem id={'teamReports'}>
                <div className={styles.navItemHeaderContainer}>
                  <div className={styles.navItemHeader}>
                    <SvgIcon
                      src={SvgIconSrc.pieChart}
                      size={20}
                      className={styles.navItemHeaderIcon}
                    />
                    <h6 className="navbar-heading color-white">
                      {'Department Reports'}
                    </h6>
                  </div>
                  <SvgIcon
                    src={SvgIconSrc.arrowChevron}
                    size={16}
                    rotate={isTeamReportCollapsed ? '0' : '180'}
                    onClick={() => {
                      setIsTeamReportCollapsed(!isTeamReportCollapsed);
                    }}
                  />
                </div>
              </NavItem>
            </React.Fragment>
          )}
          <div
            style={{
              display: isTeamReportCollapsed ? 'none' : 'block',
              transition: 'display 0.3s ease',
            }}
          >
            {map(filteredTeamReportItems, (navItem) => {
              // Special handling for alerts item to show badge
              const isAlertsItem = navItem.id === 'alerts';
              const isNotificationsItem = navItem.id === 'notifications';
              const hasUnreadAlerts = isAlertsItem && unreadAlertsCount > 0;

              return (
                <NavItem
                  className="cursor-pointer"
                  id={navItem.id}
                  key={navItem.id}
                >
                  <NavLink
                    onClick={() => handleRouting(navItem)}
                    className={classNames(styles.navItemLink, {
                      [styles.navItemLink_active]: getIsNavItemActive(navItem),
                    })}
                  >
                    <div
                      className={classNames(styles.vertical, {
                        [styles.vertical_active]: getIsNavItemActive(navItem),
                      })}
                    />
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Normal}
                      style={{ caretColor: 'transparent' }}
                    >
                      {navItem.title}
                    </Text>
                    {isAlertsItem && unreadAlertsCount > 0 && (
                      <Badge
                        color="danger"
                        pill
                        className="ml-1"
                        style={{
                          fontSize: '10px',
                          minWidth: '18px',
                          height: '18px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0 4px',
                        }}
                      >
                        {unreadAlertsCount > 99 ? '99+' : unreadAlertsCount}
                      </Badge>
                    )}
                    {isNotificationsItem && unreadNotificationsCount > 0 && (
                      <Badge
                        color="danger"
                        pill
                        className="ml-1"
                        style={{
                          fontSize: '10px',
                          minWidth: '18px',
                          height: '18px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0 4px',
                        }}
                      >
                        {unreadNotificationsCount > 99
                          ? '99+'
                          : unreadNotificationsCount}
                      </Badge>
                    )}
                    {/* </a> */}
                  </NavLink>
                </NavItem>
              );
            })}
          </div>
          {hasActiveCompany && (
            <React.Fragment>
              <hr className="my-1" />
              <NavItem id={'management'}>
                <div className={styles.navItemHeaderContainer}>
                  <div className={styles.navItemHeader}>
                    <SvgIcon
                      src={SvgIconSrc.pieChart}
                      size={20}
                      className={styles.navItemHeaderIcon}
                    />
                    <h6 className="navbar-heading color-white">
                      {'Management'}
                    </h6>
                  </div>
                  <SvgIcon
                    src={SvgIconSrc.arrowChevron}
                    style={{ marginLeft: '12px' }}
                    size={16}
                    color="#FFF"
                    rotate={isManagementCollapsed ? '0' : '180'}
                    onClick={() => {
                      setIsManagementCollapsed(!isManagementCollapsed);
                    }}
                  />
                </div>
              </NavItem>
            </React.Fragment>
          )}
          <div
            style={{
              display: isManagementCollapsed ? 'none' : 'block',
              transition: 'display 0.3s ease',
            }}
          >
            {map(filteredManagementItems, (navItem) => {
              return (
                <NavItem
                  className="cursor-pointer"
                  id={navItem.id}
                  key={navItem.id}
                >
                  <NavLink
                    onClick={() => handleRouting(navItem)}
                    className={classNames(styles.navItemLink, {
                      [styles.navItemLink_active]: getIsNavItemActive(navItem),
                    })}
                  >
                    <div
                      className={classNames(styles.vertical, {
                        [styles.vertical_active]: getIsNavItemActive(navItem),
                      })}
                    />
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Normal}
                      style={{ caretColor: 'transparent' }}
                    >
                      {navItem.title}
                    </Text>

                    {/* </a> */}
                  </NavLink>
                </NavItem>
              );
            })}
          </div>
        </div>
        <div className={styles.navItemsContainerFooter}>
          <Button
            text="Log Out"
            variant={buttonVariants.primary_light}
            icon={<MdLogout size={20} color="#fff" />}
            onClick={() => {
              dispatch({
                type: authActionTypes.LOGOUT_ACTIVE_ACCOUNT,
              });
            }}
          />
        </div>
      </Nav>
    </BlockUi>
  );
};

CustomNavItem.propTypes = {};

export default CustomNavItem;
